<template>
  <div id="voyage-plan-list">
    <div class="vx-card p-6 list-container">
      <div class="list-container-inner">
        <div class="control-header">

          <vs-row
            vs-align="flex-end"
            vs-type="flex"
            vs-justify="space-between"
            class="search-area"
          >
            <vs-col vs-lg="5" vs-sm="12" class="control-element">
              <vs-dropdown vs-trigger-click class="cursor-pointer" :color="AISEA_COLOR.BLUE">
                <div
                  class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                >
                  <span class="mr-2"
                    >{{
                      currentPage * paginationPageSize - (paginationPageSize - 1)
                    }}
                    -
                    {{
                      totalVoyageHistory - currentPage * paginationPageSize > 0
                        ? currentPage * paginationPageSize
                        : totalVoyageHistory
                    }}
                    / {{ totalVoyageHistory }}</span
                  >
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="onChangePageSize(10)">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="onChangePageSize(20)">
                    <span>20</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="onChangePageSize(30)">
                    <span>30</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-col>
            <vs-col vs-lg="2" vs-sm="12" class="control-element">
              <label>操船者絞り込み</label>
              <v-select
                v-model="searchUserIds"
                :color="AISEA_COLOR.BLUE"
                multiple
                :closeOnSelect="false"
                :clearable="false"
                :options="optionUsers"
                name="searchUserIds"
                class="w-full"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              >
                <template v-slot:no-options>操船者が見つかりません。</template>
              </v-select>
            </vs-col>
            <vs-col vs-lg="2" vs-sm="12" class="control-element">
              <label>船舶絞り込み</label>
              <v-select
                v-model="searchVesselIds"
                :color="AISEA_COLOR.BLUE"
                multiple
                :closeOnSelect="false"
                :clearable="false"
                :options="optionVessels"
                name="searchVesselIds"
                class="w-full"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              >
                <template v-slot:no-options>船舶が見つかりません。</template>
              </v-select>
            </vs-col>
            <vs-col vs-lg="2" vs-sm="12" class="control-element">
              <vs-button class="search-button" @click="onSearch" :color="AISEA_COLOR.BLUE">検索</vs-button>
            </vs-col>
          </vs-row>
        </div>

        <div class="table-container">
          <div v-if="voyageData.length == 0 && dataReady" class="not-found-message-area">
            <span class="not-found-message aisea-text-14-400-gray">航路計画が見つかりませんでした</span>
          </div>
          <div class="table-area-wrapper">
            <div class="table-area">
              <div class="header row aisea-text-14-700-dark-gray">
                <div
                  class="cell cell-select">
                </div>
                <div
                  class="cell"
                  v-for="(column, index) in columns"
                  :key="index"
                  :class="'cell-' + column.key"
                  :style="'width:' + column.width">
                  {{column.label}}
                </div>
              </div>
              <div class="data row aisea-text-14-400-black"
                v-for="(rowData, index) in voyageData"
                :key="index">
                <div
                  class="cell cell-select"
                >
                  <vs-checkbox v-model="checkedVoyages" :vs-value="rowData.voyageId" :color="AISEA_COLOR.BLUE" :class="{'check-disabled': disableCheck(rowData.voyageId)}"></vs-checkbox>
                </div>
                <div class="clickable-cell-container" @click="goToDetail(rowData)">
                  <div class="cell"
                    v-for="(column, index) in columns"
                    :key="index"
                    :class="'cell-' + column.key"
                    :style="'width:' + column.width">
                    <div v-if="rowData[column.key] == null">
                      -
                    </div>
                    <div v-else-if="column.key == 'startedAt' || column.key == 'endedAt'">
                      {{getJstTime(rowData[column.key])}}
                    </div>
                    <div v-else-if="column.key == 'mile'" :class="{'mile-over-value': rowData['mileOverValue']}">
                      {{roundNumberK(rowData[column.key])}}
                      {{column.unit}}
                    </div>
                    <div v-else>
                      {{roundNumber(rowData[column.key])}}
                      {{column.unit}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <vs-row
          vs-align="flex-end"
          vs-type="flex"
          vs-justify="space-between"
          class="footer-control-area"
        >
          <vs-col vs-lg="4" vs-sm="12">
            <vs-button @click="goToCompare()" :disabled="!showCheckedVoyageButton" :color="AISEA_COLOR.BLUE" class="checked-jump-button">選択した航路を表示</vs-button>
          </vs-col>
          <vs-col vs-lg="8" vs-sm="12">
            <div class="pagination-area">
              <vs-pagination :color="AISEA_COLOR.BLUE" :total="totalPages" :max="7" v-model="currentPage" />
            </div>
          </vs-col>
        </vs-row>
      </div>
    </div>
    <vs-popup class="max-checked-popup" title="航路選択" :active.sync="maxCheckedPopup">
      <p>
        選択できる航路は７航路までです。
      </p>
      <vs-button class="popup-button" @click="maxCheckedPopup = false" :color="AISEA_COLOR.BLUE">OK</vs-button>
    </vs-popup>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import moment from "moment";
import vSelect from "vue-select";
import {ColorMixin} from "@/mixins";

export default {
  mixins: [ColorMixin],
  components: {
    vSelect,
  },
  data() {
    return {
      currentPage: 1,
      dataReady: false,

      checkedVoyages: [],
      maxCheckedCount: 7,
      maxCheckedPopup: false,

      fuelEconomyMap: [], // idからfuelを引くmap

      paginationPageSize: 10,
      // Search params
      searchVesselIds: [],
      searchUserIds: [],
      savedParams: null,

      columns: [
        {
          key: "vesselName",
          label: "船名",
          width: "140px",
          unit: null
        },
        {
          key: "startedAt",
          label: "出港",
          width: "140px",
          unit: null
        },
        {
          key: "endedAt",
          label: "入港",
          width: "140px",
          unit: null
        },
        {
          key: "seaRoute",
          label: "航路",
          width: "120px",
          unit: null
        },
        {
          key: "pilot",
          label: "操船者",
          width: "110px",
          unit: null
        },
        {
          key: "distance",
          label: "航行距離",
          width: "110px",
          unit: "mile"
        },
        {
          key: "speed",
          label: "平均船速",
          width: "110px",
          unit: "mile/h"
        },
        {
          key: "petrol",
          label: "燃料油消費量（A重油/C重油）",
          width: "220px",
          unit: null
        },
        {
          key: "mile",
          label: "平均マイル消費",
          width: "120px",
          unit: "KL/mile"
        },
      ],
    };
  },
  async mounted() {
    let routerViewElement = document.getElementsByClassName("router-view")
    routerViewElement[0].style.padding = "2.2rem"

    await this.$store.dispatch("enterpriseVoyageHistory/getSearchInfo");

    this.dataReady = true

    const query = this.$route.query
    if (Object.prototype.hasOwnProperty.call(query, "user_ids")){
      const savedUserIds = query.user_ids instanceof Array ? query.user_ids : [query.user_ids]
      this.searchUserIds = savedUserIds.map(element => {
        const index = this.optionUsers.findIndex(option => option.value == element) // id
        return this.optionUsers[index]
      })
    }
    if (Object.prototype.hasOwnProperty.call(query, "vessel_ids")){
      const savedVesselIds = query.vessel_ids instanceof Array ? query.vessel_ids : [query.vessel_ids]
      this.searchVesselIds = savedVesselIds.map(element => {
        const index = this.optionVessels.findIndex(option => option.value == element) // id
        return this.optionVessels[index]
      })
    }

    this.searchVoyageHistories(false)
  },
  watch: {
    currentPage() {
      this.searchVoyageHistories(false);
    },
    async voyageHistories(value) {
      const ids = value.map(element => element.id)
      if (value.length > 0) this.fuelEconomyMap = await this.getVoyageFuelEconomyArray(ids)
    },
    checkedVoyages(value) {
      if (value.length > this.maxCheckedCount) {
        this.maxCheckedPopup = true
        this.checkedVoyages.pop()
      }
    }
  },
  computed: {
    ...mapGetters({
      voyageHistories: "enterpriseVoyageHistory/getEnterpriseVoyageHistories",
      users: "enterpriseVoyageHistory/getSearchUsers",
      vessels: "enterpriseVoyageHistory/getSearchVessels"
    }),
    voyageData() {
      return this.voyageHistories.map(element => {
        let petrol = null
        let totalPetrol = null
        let mile = null
        let seaRoute = null
        let distance = element.total_distance
        let speed = element.max_speed
        let time = null
        if (element.properties) {
          const aFuel = element.properties.a_fuel_consumption ? element.properties.a_fuel_consumption : "-"
          const cFuel = element.properties.c_fuel_consumption ? element.properties.c_fuel_consumption : "-"
          petrol = aFuel != "-" && cFuel != "-" ? this.roundNumberK(element.properties.a_fuel_consumption) + " KL / " + this.roundNumberK(element.properties.c_fuel_consumption) + " KL" : null
          totalPetrol = Number(element.properties.a_fuel_consumption) + Number(element.properties.c_fuel_consumption)
          mile = totalPetrol && element.properties.total_distance ? totalPetrol / Number(element.properties.total_distance) : null
          seaRoute = element.properties ? element.properties.route_name : null
          distance = element.properties.total_distance ? element.properties.total_distance : element.total_distance
          speed = element.properties.average_speed ? element.properties.average_speed : element.max_speed
          time = element.properties.total_time ? element.properties.total_time : null
        }

        const target = this.fuelEconomyMap.find(fuelInfo => fuelInfo.id == element.id)
        const mileOverValue = target ? target.th < mile : false

        return {
          vesselName: element.vessel.name_ja || element.vessel.name,
          vesselId: element.vessel.id,
          voyageId: element.id,
          seaRoute: seaRoute,
          distance: distance,
          speed: speed,
          petrol: petrol,
          mile: mile,
          pilot: element.user.name,
          endedAt: element.ended_at,
          startedAt: element.started_at,
          properties: element.properties,
          totalPetrol: totalPetrol,
          time: time,

          mileOverValue: mileOverValue
        }
      })
    },
    checkedVoyageData() {
      return this.checkedVoyages.map(voyageId => this.voyageData.find(element => element.voyageId == voyageId)) // チェックされたvoyageIdから航路データを割り出す
    },
    ...mapState({
      session: state => state.session.session,
      pageable: state => state.enterpriseVoyageHistory.pageable,
      projectEnterpriseId: state => state.voyageHistory.project.enterpriseId,
      defaultImage: function() {
        return "no_image_ship_s";
      }
    }),
    optionUsers() {
      return this.users.flatMap(d => {
        return { label: d.name || d.name_en, value: d.user_id };
      });
    },
    optionVessels() {
      return this.vessels.flatMap(d => {
        return { label: d.name_ja || d.name, value: d.id };
      });
    },
    totalPages() {
      if (this.pageable) return this.pageable.total_pages;
      else return 0;
    },
    totalVoyageHistory() {
      if (this.pageable) return this.pageable.total_elements;
      else return 0;
    },
    showCheckedVoyageButton() {
      return this.checkedVoyages.length > 0
    }
  },
  methods: {
    ...mapActions({
      getEnterpriseVoyageHistories:
        "enterpriseVoyageHistory/getEnterpriseVoyageHistories",
      getVoyageFuelEconomyArray:
        "ecoShipVoyagePlan/getVoyageFuelEconomyArray",
      setSeaRouteDetailCondition:
        "ecoShipVoyagePlan/setSeaRouteDetailCondition",
    }),
    getJstTime(time) {
      return moment(time).format("YYYY/MM/DD HH:mm")
    },
    goToDetail(voyageData) {
      this.setSeaRouteDetailCondition(voyageData)
      this.$router.push({
        name: "addon-eco-ship-voyage-plan-detail",
        params: this.savedParams
      });
    },
    goToCompare() {
      this.$router.push({
        name: "addon-eco-ship-voyage-plan-compare",
        query: {voyageIds: this.checkedVoyages},
        params: this.savedParams
      });
    },
    async searchVoyageHistories(replaceUrlParam) {
      let requestParams = {
        user_ids: this.searchUserIds.flatMap(e => e.value),
        vessel_ids: this.searchVesselIds.flatMap(e => e.value),
        page: this.getCurrentPage(),
        limit: this.paginationPageSize
      };
      const comparedParams = {
        user_ids: requestParams.user_ids,
        vessel_ids: requestParams.vessel_ids
      }
      // 絞り込み条件の変更を検知してURLパラメータを変更する
      if ((JSON.stringify(this.savedParams) != JSON.stringify(comparedParams)) && replaceUrlParam) {
        this.$router.replace({
          name: "addon-eco-ship-voyage-plan-list",
          query: {
            user_ids: requestParams.user_ids,
            vessel_ids: requestParams.vessel_ids
          }
        })
      }

      this.savedParams = { ...comparedParams }

      this.$vs.loading();
      await this.$store
        .dispatch(
          "enterpriseVoyageHistory/getEnterpriseVoyageHistories",
          requestParams
        )
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    getCurrentPage() {
      return this.currentPage - 1;
    },
    onSearch() {
      this.currentPage = 1;
      this.searchVoyageHistories(true);
    },
    onChangePageSize(size) {
      this.paginationPageSize = size

      this.currentPage = 1;
      this.searchVoyageHistories(false);
    },
    roundNumber(target) {
      return typeof target == 'number' ? Math.round(target * 100) / 100 : target
    },
    roundNumberK(target) {
      return typeof target === 'number' ? Math.round(target / 10) / 100 : target
    },
    disableCheck(voyageId) {
      return this.checkedVoyages.length >= this.maxCheckedCount && !this.checkedVoyages.includes(voyageId)
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
#voyage-plan-list {
  .not-found-message-area {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    position: absolute;
  }
  .table-area {
    width: fit-content;
  }
  .table-container {
    position: relative;
  }
  .table-area-wrapper {
    overflow-x: scroll;
    position: relative;
    height: 560px;
    // height: calc(100vh - 330px);
  }
  .control-header {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    .control-element {
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .search-area {
      margin-left: auto;
    }
    .search-button {
      display: block;
    }
  }

  .checked-jump-button {
    margin-top: 14px;
  }
  .pagination-area {
    margin-top: 20px;
  }
  .header {
    font-weight: bold;
  }
  .row {
    min-height: 49px;
    height: fit-content;
    display: flex;
    border-bottom: solid 1px $aisea-light-white;
  }
  .clickable-cell-container {
    display: flex;
    transition: 0.3s;
    cursor: pointer;
    &:hover {
      background: $aisea-white;
    }
  }
  .cell {
    display: flex;
    margin-right: 20px;
    padding: 5px 10px;
    align-items: center;
    &.cell-vesselName {
      overflow-wrap: anywhere;
    }
    &.cell-select {
      width: 30px;
      .check-disabled {
        input {
          cursor: default;
        }

      }
    }
  }
  .mile-over-value {
    color: $aisea-red;
  }
  .checked-jump-button {
    &.vs-button:disabled {
      opacity: 1;
      background: $aisea-gray !important;
    }
  }
}

.max-checked-popup {
  .popup-button {
    margin-top: 10px;
  }
}
</style>
